import { CustomAsyncSelectOption } from 'modules/_shared/components/CustomAsyncSelect/types/CustomAsyncSelectOption';

export const capitalIncreaseModalInitValue = {
  data: {
    date: '',
    comments: '',
    file: undefined,
    notaryName: '',
    notaryProtocol: '',
    notaryCity: '',
    scriptureView: true,
    lastOperationDate: '',
    totalSharesToAdd: 0,
    nominalValue: 0,
    selectedPartner: '',
    partnerOptions: [],
    showAddPartnerSection: false,
    sharesToAdd: 0,
    remainingShares: 0,
    hasPremium: false,
    premium: 0,
    selectedHoldingClass: '',
    selectedHoldingClassOption: null,
    holdingClassOptions: [],
    availableRange: { from: 0, to: 0 },
    historyMovements: [],
    isValidateRangeEnabled: false,
    useFirstAvailableRange: true,
    isLoadingRange: false,
    isLoading: false,
  },
  actions: {
    handleCloseModal(): void {},
    handleChangeDate(): void {},
    handleChangeComments(): void {},
    handleChangeFile(): void {},
    handleChangeNotaryName(): void {},
    handleChangeNotaryProtocol(): void {},
    handleChangeNotaryCity(): void {},
    handleChangeTotalSharesToAdd(): void {},
    handleChangePartner(): void {},
    handleSearchPartnerByTerm: async (): Promise<
      CustomAsyncSelectOption[] | undefined
    > => undefined,
    handleAddPartner(): void {},
    handleCloseAddPartnerSection(): void {},
    handleChangeSharesToAdd(): void {},
    handleChangeHasPremium(): void {},
    handleChangePremium(): void {},
    handleChangeHoldingClass(): void {},
    handleFetchHoldingClassByTerm: async (): Promise<
      CustomAsyncSelectOption[] | undefined
    > => undefined,
    handleValidateRange(): void {},
    handleChangeUseFirstAvailableRange(): void {},
    handleSaveMovement(): void {},
    handleSaveCapitalIncrease(): void {},
    handleUploadMock(): void {},
  },
};
